export const strToList = (str: string | null) => str?.split(',') ?? [];
export const listToStr = (list: string[]) => {
  let str: string = '';
  list.map((item) => {
    str += `${item},`;
  });
  if (list.length > 0) str = str.slice(0, -1);
  return str;
};
